import React from 'react';
import ReactDOM from 'react-dom/client';
import "../src/style/css/iconsax.css";
import ALLRoutes from './feature-module/router/router.jsx';
import { BrowserRouter } from 'react-router-dom';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import './index.scss';
import { Provider } from 'react-redux';
import store from './core/redux/store.jsx';
import "../node_modules/@tabler/icons-webfont/dist/tabler-icons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { Toaster } from 'react-hot-toast'; // 🔥 Add this line

import { base_path } from 'environment';
const style = document.createElement('style');
style.innerHTML = `
  @keyframes slide-in-right {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={base_path}>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              animation: 'slide-in-right 0.4s ease forwards',
              marginTop: '10%',
            },
          }}
        />


        <ALLRoutes />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
